import Vue from 'vue'
import BzbsApi from '@/core/Http/BzbsApi.js'
import Cache from '@/helper/Cache.js'
import Account from '@/helper/AccountHelper.js'
import DatetimeHelper from '@/helper/DatetimeHelper.js'

/**
 * @method getCustomerStore
 * @method postDeviceResume
 * @method postRegister
 * @method apiBzbsLogin
 * @method apiBzbsFacebookLogin
 * @method apiBzbsDisconnect
 * @method getForgetPassword
 * @method postForgetPassword
 * @method postValidateEmail
 * @method postResetPassword
 * @method getVerifyEmail
 */

export default {
  config: function () {
    return Vue.bzbsConfig
  },
  token: function () {
    return Account.getCacheToken() ? Account.getCacheToken() : null
  },
  ewallet_token: function () {
    return Account.getCacheWalletToken() ? Account.getCacheWalletToken() : null
  },
  app_id: function () {
    if (Cache.get('BzbsUser_' + Account.getCacheCustom('app_id')) != null) {
      if (
        Cache.get('BzbsUser_' + Account.getCacheCustom('app_id')).appId !=
        undefined
      ) {
        return Cache.get('BzbsUser_' + Account.getCacheCustom('app_id')).appId
      } else {
        return Account.getCacheCustom('app_id')
      }
    } else {
      return Account.getCacheCustom('app_id')
    }
  },
  agency_id: function () {
    return Cache.get('BzbsUser_' + Account.getCacheCustom('app_id')).sponsorId
  },
  getCustomerStore: function () {
    var strUrl =
      this.config().bzbModuleUrl +
      '/crmpluscustomer/store_by_app?device_app_id=' +
      this.app_id() +
      '&identity=' +
      DatetimeHelper.getAccessTime()
    return BzbsApi.connectBzbsGet(strUrl, null, null)
  },
  postDeviceResume: function () {
    let params = {
      device_app_id: this.app_id(),
    }
    var strUrl = this.config().bzbUrlService + '/auth/device_resume'
    return BzbsApi.connectBzbsPost(strUrl, this.token(), params)
  },
  postRegister: function (params, token) {
    var data = {}
    if (params.username) data.username = params.username
    if (params.password) data.password = params.password
    if (params.confirmpassword) data.confirmpassword = params.confirmpassword
    if (params.app_id) data.app_id = params.app_id
    if (params.firstname) data.firstname = params.firstname
    if (params.lastname) data.lastname = params.lastname
    if (params.email) data.email = params.email
    if (params.contact_number) data.contact_number = params.contact_number
    if (typeof params.gender == Array && params.gender.length > 0) {
      data.gender = params.gender
    } else if (typeof params.gender !== Array && params.gender) {
      data.gender = params.gender
    }
    if (params.birthdate) data.birthdate = params.birthdate
    if (params.idcard) data.idcard = params.idcard
    if (params.custom_info)
      data.custom_info = JSON.stringify(params.custom_info)
    if (params.refcode) data.refcode = params.refcode
    if (params.otp) params.otp = data.otp = params.otp
    var strUrl = this.config().bzbUrlService + '/auth/register'

    if (token) {
      return BzbsApi.connectBzbsPost(strUrl, token, data)
    } else {
      return BzbsApi.connectBzbsPost(strUrl, null, data)
    }
  },
  apiBzbsLogin: function (params, token = null) {
    var strUrl = this.config().bzbUrlService + '/auth/bzbs_login'
    return BzbsApi.connectBzbsPost(strUrl, token, params)
  },
  apiBzbsFacebookLogin: function (params, token) {
    var data = {
      access_token: params.access_token,
      app_id: this.app_id(),
    }
    var strUrl = this.config().bzbUrlService + '/auth/login'
    if (token) {
      return BzbsApi.connectBzbsPost(strUrl, token, data)
    } else {
      return BzbsApi.connectBzbsPost(strUrl, null, data)
    }
  },
  apiBzbsDisconnect: function (params) {
    //Example param value
    // facebook: true,
    // google: true,
    // line: true,
    // bzbs: true
    var strUrl = this.config().bzbUrlService + '/auth/disconnect'
    return BzbsApi.connectBzbsPost(strUrl, this.token(), params)
  },
  getForgetPassword: function (email) {
    var strUrl =
      this.config().bzbUrlService + '/profile/' + email + '/forget_password'
    return BzbsApi.connectBzbsGetForgot(strUrl, null, null)
  },
  postForgetPassword: function (email) {
    var data = {
      email: email,
    }
    var strUrl = this.config().bzbModuleUrl + '/crmpluscustomer/forget_password'
    return BzbsApi.connectBzbsPostForgot(strUrl, null, data)
  },
  postValidateEmail: function (obj) {
    let params = {
      refCode: obj.refcode,
      otp: obj.otp,
    }
    var strUrl = this.config().bzbUrlService + '/profile/me/validate_email'
    return BzbsApi.connectBzbsPost(strUrl, obj.token, params)
  },
  postResetPassword: function (obj) {
    let params = {
      change: obj.nempassword,
      refcode: obj.refcode,
    }
    var strUrl =
      this.config().bzbUrlService + '/profile/' + obj.email + '/forget_password'
    return BzbsApi.connectBzbsPost(strUrl, null, params)
  },
  getVerifyEmail: function () {
    var strUrl = this.config().bzbUrlService + '/profile/me/verify_email'
    return BzbsApi.connectBzbsGet(strUrl, this.token(), null)
  },
  postSyncEmail: function (params) {
    var strUrl = this.config().bzbModuleUrl + '/crmpluscustomer/sync_email'
    return BzbsApi.connectBzbsPost(strUrl, this.token(), params)
  },
}
